<template>
    <PublicLandingPage :page="landingPages.weddingCakes" />
</template>

<script setup lang="ts">
import { landingPages } from '~/fixtures';
</script>
